<template>
  <div id="live_list">
    <div class="bread">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{path: '/watch_index'}">缴费客户观看直播情况</el-breadcrumb-item>
        <el-breadcrumb-item>缴费客户观看直播明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bottom cont">
      <div class="titlebox">
        <div class="title">缴费客户观看直播明细</div>
        <div class="notice">
          <span class="right_grid">
            <span class="refresh" @click="refresh">刷新</span>

          </span>
        </div>
      </div>
      <div class="string"></div>
      <!-- 表 -->
      <div class="table_box">
        <el-table v-loading="loading" :data="tableData" stripe style="width: 98%; margin: 0 auto;" :height="tableHeight"
          :header-cell-style="{backgroundColor: '#FAFAFA'}">
          <el-table-column label="序号" width="60" align="center" fixed="left">
            <template #default="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户备注" prop="remark" align="center" fixed="left">
            <template #default="scope">
              <span>{{ scope.row.remark	}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户头像" prop="img" align="center" fixed="left">
            <template #default="scope">
              <img :src="scope.row.avatar" :style="{width: '40px',height: '40px'}" />
            </template>
          </el-table-column>
          <el-table-column label="直播主题" width="120" align="left" fixed="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.theme}}</span>
            </template>
          </el-table-column>
          <el-table-column label="直播老师" width="120" align="left" fixed="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.guest}}</span>
            </template>
          </el-table-column>
          <el-table-column label="进入时间" align="left" fixed="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.first_in_time}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable label="直播时间" align="center" fixed="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span>{{scope.row.living_start_new}}</span>
            </template>
          </el-table-column>
          <el-table-column label="观看总时长" align="left">
            <template #default="scope">
              <span>{{scope.row.his_learn_time_new}}</span>
            </template>
          </el-table-column>
          <el-table-column label="直播观看时长" align="center">
            <template #default="scope">
              <span>{{scope.row.his_learning_time_new}}</span>
            </template>
          </el-table-column>
          <el-table-column label="回看观看时长" align="center">
            <template #default="scope">
              <span>{{scope.row.his_learned_time_new}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row class="paging_box" justify="space-between">
          <el-pagination class="paging" @size-change="sizeChange" @current-change="currentChange"
            :current-page="page.current" :page-sizes="page.pageSizes" :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import './assets/less/list.less';
  import list_model from "./model/model";
  import common_model from '@/common/model';
  import moment from "moment/moment";
  import {
    reactive
  } from "vue";
  var that = null
  export default {
    components: {},
    data() {
      that = this
      return {
        unionid: that.$route.query.unionid || '', //部门类型
        userid:that.$route.query.userid || '',
        loading: false,
        tableHeight: 350,
        activeName: 'get_e_live_list',
        tableData: [],
        page: {
          loading: false,
          pageSize: 10,
          total: 0,
          size: 10,
          current: 1,
          pageSizes: [10, 20, 50, 100],
        },
        search:{}
      }
    },
    mounted() {
      that.$nextTick(() => {
        that.tableHeight = document.querySelector('.table_box').clientHeight - 34;
        that.init()
      });
    },
    methods: {
      init() {
        //用户权限处理
        common_model.getUserInfo().then((res) => {
          that.userInfo = res;
          that.get_e_live_list()
        });
      },
      /**
       * 获取列表数据
       */
      get_e_live_list() {
        that.loading = true;
        let params = reactive({
          unionid:	that.unionid,
          userid: that.userid
        })
        list_model.get_watch_living_detail(params).then(res => {
          that.loading = false;
          if (res.code === 0) {
            let list = res.list
            for (let i in list) {
              let item = list[i]
              item.living_start_new = item.living_start.split(".")[0]
              item.his_learn_time_new = that.formatSecondsToHMS(item.his_learn_time)
              item.his_learning_time_new = that.formatSecondsToHMS(item.his_learning_time)
              item.his_learned_time_new = that.formatSecondsToHMS(item.his_learned_time)
            }

            that.tableData = res.list;
            that.page.total = res.total;
          }
        });
      },
      formatSecondsToHMS(seconds) {
        // 将小数秒数转换为整数秒数
        const new_seconds = Math.round(seconds);
        // 计算小时数
        const hours = Math.floor(new_seconds / 3600);
        // 计算剩余的分钟数
        const minutes = Math.floor((new_seconds % 3600) / 60);
        // 计算剩余的秒数
        const secs = new_seconds % 60;

        // 格式化输出，确保每个部分都是两位数（如果需要）
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = secs.toString().padStart(2, '0');
        let result = ""
        if(formattedHours != "00"){
          result = `${formattedHours}小时`
        }
        if(formattedMinutes != "00"){
          result += `${formattedMinutes}分`
        }
        if(formattedSeconds != "00"){
          result += `${formattedSeconds}秒`
        }
        if(result == ""){
          result = "0秒"
        }
        // 返回格式化的字符串
        return result
      },
      /* 数据刷新 */
      refresh() {
        that.get_e_live_list()
      },
      /**
       * 分页-改变分页大小
       */
      sizeChange(v) {
        that.page.size = v;
        that.page.current = 1;
        that.get_e_live_list();
      },
      /**
       * 分页-当前页数据刷新
       */
      currentChange(v) {
        that.page.current = v;
        that.get_e_live_list();
      },
      /**
       * 时间格式化
       * @param time 以秒为单位的时间戳
       */
      formatDate(date) {
        return moment(date).format('YYYY-MM-DD')
      },
    },
    filters: {

    }
  }
</script>

<style>
  * {
    padding: 0;
  }
</style>
